import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilderResizer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M29.5 1C32.5376 1 35 3.46243 35 6.5V16.8506C35 26.874 26.874 35 16.8506 35H6.5C3.46243 35 1 32.5376 1 29.5C1 26.4624 3.46243 24 6.5 24H14.667C19.8214 23.9998 23.9998 19.8214 24 14.667V6.5C24 3.46243 26.4624 1 29.5 1Z",
		fill: "#F5F5F4",
		stroke: "#A8A29D",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgBuilderResizer);
export { ForwardRef as ReactComponent };
